(function () {
  function initReview(container) {
    if (container.dataset.reviewVotesReady === 'true') return;
    container.dataset.reviewVotesReady = 'true';

  const blockId = container.getAttribute('data-block-id');
  const initialLikes = parseInt(container.getAttribute('data-initial-likes')) || 0;
  const initialDislikes = parseInt(container.getAttribute('data-initial-dislikes')) || 0;

  const likeBtn = container.querySelector('.js-like-btn');
  const dislikeBtn = container.querySelector('.js-dislike-btn');
  const likeCountSpan = container.querySelector('.js-like-count');
  const dislikeCountSpan = container.querySelector('.js-dislike-count');

  // Storage Key
  const storageKey = 'shopify-review-votes-' + blockId;

  // 1. Load Data from LocalStorage (or use defaults)
  function loadState() {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      return JSON.parse(stored); 
    } else {
      // Default state
      return {
        likes: initialLikes,
        dislikes: initialDislikes,
        userVote: null // 'up', 'down', or null
      };
    }
  }

  // 2. Render the UI based on state
  function render(state) {
    likeCountSpan.textContent = state.likes;
    dislikeCountSpan.textContent = state.dislikes;

    // Toggle Active Classes
    if (state.userVote === 'up') {
      likeBtn.classList.add('active-like');
      dislikeBtn.classList.remove('active-dislike');
    } else if (state.userVote === 'down') {
      likeBtn.classList.remove('active-like');
      dislikeBtn.classList.add('active-dislike');
    } else {
      likeBtn.classList.remove('active-like');
      dislikeBtn.classList.remove('active-dislike');
    }
  }

  // Initialize
  let currentState = loadState();
  render(currentState);

  // 3. Event Listeners
  likeBtn.addEventListener('click', function() {
    if (currentState.userVote === 'up') {
      // Toggle OFF
      currentState.likes--;
      currentState.userVote = null;
    } else {
      // If currently disliked, remove dislike first
      if (currentState.userVote === 'down') {
        currentState.dislikes--;
      }
      // Toggle ON
      currentState.likes++;
      currentState.userVote = 'up';
    }
    saveAndRender();
  });

  dislikeBtn.addEventListener('click', function() {
    if (currentState.userVote === 'down') {
      // Toggle OFF
      currentState.dislikes--;
      currentState.userVote = null;
    } else {
      // If currently liked, remove like first
      if (currentState.userVote === 'up') {
        currentState.likes--;
      }
      // Toggle ON
      currentState.dislikes++;
      currentState.userVote = 'down';
    }
    saveAndRender();
  });

  function saveAndRender() {
    localStorage.setItem(storageKey, JSON.stringify(currentState));
    render(currentState);
  }
  }

  function initAll() {
    document.querySelectorAll('.review-card[data-block-id]').forEach(initReview);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
